const list = {
  data() {
    return {
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pageSizes: [15, 20, 25, 30],
      pageLayout: "total, prev, pager, next",
      tableList: [],
      getTableUrl: "",
      getTableProxyType: "",
      searchCopy: {}
    }; 
  },
  methods: {
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentChange();
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.currentChange();
      this.getTableData();
    },
    currentChange() {
      this.searchCopy = Object.assign(this.searchCopy, {
        page_index: this.pageNum,
        page_size: this.pageSize
      });
    },
    getTableData(url, proxyType, data, tableName) {
      if (this.pageNum < 1) {
        this.pageNum = 1;
        this.searchCopy.page_index = 1;
      }
      this.loading = true;
      //在第一次请求时候记录 url proxyType data
      this.getTableUrl = url ? url : this.getTableUrl;
      this.getTableProxyType = proxyType ? proxyType : this.getTableProxyType;
      this.searchCopy = data ? data : this.searchCopy;
      this.tableName = tableName ? tableName : this.tableName;
      //加入params配合goBack方法的params返回
      this.$router.push({
        query: this.searchCopy,
        params: this.$route.params
      });
      return new Promise((resolve, reject) => {
        this.tableList = [];
        if (this.getTableProxyType === "get") {
          this.$axios.get(this.getTableUrl, {
            params: this.searchCopy
          }).then(result => {
            this.listSuccess(result);
            resolve(result);
          }).catch(error => {
            this.listException(error);
          });
        } else if (this.getTableProxyType === "post") {
          this.$axios.post(this.getTableUrl, this.searchCopy).then(result => {
            this.listSuccess(result);
            resolve(result);
          }).catch(error => {
            this.listException(error);
          });
        }
      })
    },
    listSuccess(apiResult) {
      return new Promise((resolve, reject) => {
        try {
          let data,
            pagination = {};
          if (this.tableName) {
            data = this.getNode(this.tableName, apiResult.data, this);
          } else {
            data = this.getNode("data", apiResult.data, this);
          }
          pagination = this.getNode("pagination", apiResult.data, this);
          if (apiResult.data.code === 200) {
            this.tableList = data;
            this.pageNum = pagination.page_index;
            // this.pageSize = pagination.page_size ?
            //   pagination.page_size :
            //   this.pageSize;
            this.pageSize = pagination.page_size ?
              pagination.page_size :
              pagination.count;
            this.total = pagination.total_count ?
              pagination.total_count :
              pagination.total;
            this.loading = false;
            if (this.tableList.length === 0 && this.pageNum > 1) {
              this.pageNum -= 1;
              this.searchCopy.page_index -= 1;
              this.getTableData();
            }
            resolve();
          } else {
            this.loading = false;
            reject(error);
          }
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      });
    },
    //递归查询最底层子节点(因为后台结构不统一导致的问题)
    getNode(name, data, vue) {
      if (name === "data") {
        if (data instanceof Object && name in data) {
          return vue.getNode(name, data.data, vue);
        } else {
          return data;
        }
      } else {
        if (data instanceof Object && name in data) {
          return data[name];
        } else {
          return vue.getNode(name, data.data, vue);
        }
      }
    },
    listException(error) {
      this.loading = false;
      this.$message({
        type: "error",
        msg: error
      });
    }
  },
  created() {
    this.$nextTick().then(() => {
      //todo
    });
  }
};

export default list;